import React from "react";
import "react-tooltip/dist/react-tooltip.css";
import { isArray, isNotNull } from "utils/types/typeguards";
import { useScreenSize } from "utils/hooks/useScreenSize";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

type Props = {
	productTextId: string
	images?: string[]
}

function SingleProductPageGallery({ productTextId, images }: Props) {

	const screenSize = useScreenSize();
	const hasAnyElements = () => isArray(images) && isNotNull(images);

	if (!hasAnyElements()) return <></>

	const slidesPerView = screenSize.width < 1000 ? (screenSize.width < 700 ? 1 : 2) : 4;

	return (
		<div className="container">
			<Swiper
				spaceBetween={ 40 }
				modules={ [ Pagination, Autoplay ] }
				slidesPerView={ slidesPerView }
				freeMode
				pagination={ { clickable: true } }
				autoplay={ { delay: 2000, pauseOnMouseEnter: true } }
				className="mt-10 mb-20"
			>
				{
					images &&
					images.map((imageUrl, index) =>
                        <SwiperSlide key={ index } className="px-2">
							<div className="flex rounded-3xl aspect-square shadow flex-col items-center justify-center p-6">
								<img src={ imageUrl } alt={ "" }/>
							</div>
                        </SwiperSlide>,
					)
				}
			</Swiper>
		</div>
	);
}

export default SingleProductPageGallery;